import { CreateQuizCard } from '../CreateQuizCard';
import { QuizResultCard } from '../QuizResultCard';

import { Wrapper } from './RenderQuizResults.styles';

import { useMyQuizResultList } from '@/store';

export const RenderQuizResults = () => {
  const { quizResults } = useMyQuizResultList();

  const thereIsOneQuiz = quizResults?.length === 1;

  return (
    <Wrapper>
      {quizResults?.slice(0, 4).map(quizResult => (
        <QuizResultCard key={quizResult._id} quizResult={quizResult} />
      ))}
      {thereIsOneQuiz && <CreateQuizCard />}
    </Wrapper>
  );
};
